module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_9.950ee736.png";